import { DropDown } from "./DropDown";
import { setReqStatus } from "services/auth/rideApis";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { useState } from "react";

const GenderBadge = ({ gender }) => {
    if (!gender) return null;
    const isFemale = gender === "FEMALE";
    return (
        <span className={`inline-flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded-full ${
            isFemale 
                ? "bg-pink-100 text-pink-700 border border-pink-200" 
                : "bg-amber-100 text-amber-800 border border-amber-200"
        }`}>
            {isFemale ? "♀" : "♂"} {isFemale ? "Female" : "Male"}
        </span>
    );
};

const DesignationBadge = ({ email }) => {
    if (!email) return null;
    const isStudent = email.endsWith("@muj.manipal.edu");
    const isFaculty = email.endsWith("@jaipur.manipal.edu");
    if (!isStudent && !isFaculty) return null;
    return (
        <span className={`inline-flex items-center text-xs font-semibold px-2 py-0.5 rounded-full ${
            isFaculty 
                ? "bg-purple-100 text-purple-700 border border-purple-200" 
                : "bg-emerald-100 text-emerald-700 border border-emerald-200"
        }`}>
            {isFaculty ? "Faculty" : "Student"}
        </span>
    );
};

export const RequestBar = ({ request, onStatusChange }) => {
    const { id } = useParams();
    const [selected, setSelected] = useState(request.status.toLowerCase());
    const setStatusHandler = async (selected) => {
        try {
            await setReqStatus(id, request.id, selected);
            setSelected(selected);
            // Trigger parent component to refetch ride details
            if (onStatusChange) {
                onStatusChange();
            }
        } catch (error) {
            console.error("Failed to update request status:", error);
            toast.error("Failed to update status");
        }
    };

    return (
        <div className="w-full">
            {request && (
                <div className="flex gap-4 justify-between items-center border-b border-zinc-200 bg-white py-2 px-3 rounded-lg shadow-sm mb-2">
                    <div className="flex items-center gap-2">
                        <span className="font-medium text-zinc-800">{request.interestedUser.name}</span>
                        <GenderBadge gender={request.interestedUser?.gender} />
                        <DesignationBadge email={request.interestedUser?.email} />
                    </div>
                    <div className="text-xs text-zinc-500 max-md:hidden">{request.createdAt.split("T")[0]}</div>
                    <div className="flex items-center gap-2 px-1">
                        <DropDown handler={setStatusHandler} selected={selected} />
                    </div>
                </div>
            )}
        </div>
    );
};